import { api } from '../axiosInstance';
import { ApiResponseType } from '../type/commonTypes';
import { PostLoginRequest, PostLoginResponse } from '../type/types';

export const postLogin = async (request: PostLoginRequest) => {
  try {
    const res = await api.post<ApiResponseType<PostLoginResponse>>(
      '/api/auth/login',
      request,
      {
        headers: {
          'X-Auth-Method': 'COOKIE',
        },
      }
    );

    return res.data;
  } catch (error) {
    throw error;
  }
};
